import React from "react";
import { useSharedTranslation } from "@/shared/contexts/TranslateContext";
import classnames from "classnames";

import Button from "../Button";
import IconView from "../../IconView/IconView";

import EgwWebFont from "../../../assets/EgwWebFont";

import styles from "./ButtonMore.module.scss";

const ButtonMore = ({ isMoreActive, onClick, paddingLess, ...restProps }) => {
  const { t } = useSharedTranslation();

  return (
    <Button
      tabIndex={-1}
      paddingLess={paddingLess}
      variant={Button.variant.link}
      size={Button.size.small}
      color={Button.color.searchSectionPrimary}
      fontFamily={Button.fontFamily.roboto}
      onClick={onClick}
      {...restProps}
      data-less={t("less")}
      data-more={t("more")}
    >
      {t(isMoreActive ? "less" : "more")}
      &nbsp;
      <IconView
        className={classnames(styles["icon"], {
          [styles["is-less"]]: isMoreActive,
        })}
        icon={EgwWebFont["chevron-right"]}
      />
    </Button>
  );
};

export default ButtonMore;
